import React from 'react'
import { CardActions, CreateButton } from 'react-admin'

export const AssetTypeListActions = ({
  bulkActions,
  basePath,
  currentSort,
  displayedFilters,
  exporter,
  filters,
  onUnselectItems,
  resource,
  selectedIds,
  showFilter,
  total,
  filterValues,
  setFilters,
  ...rest
}) => {
  return (
    <CardActions>
      <CreateButton
        basePath={basePath}
        to={{
          pathname: `${basePath}/create`,
        }}
      />
    </CardActions>
  )
}
